<template>
	<div>
		<v-card-title v-if="title" class="d-flex align-center">
			{{ title }}
			<v-icon color="info" @click="load">$reload</v-icon>
		</v-card-title>
		<v-card-text class="pt-0">
			<v-data-table-server
				:headers="headers"
				:items="objects"
				@update:options="load"
				:items-length="parseInt(total)"
				:loading="loading"
				:show-select="showSelect"
				:single-select="singleSelect"
				v-model="selected"
				multi-sort
			>
				<template v-slot:top>
					<slot name="batchActions" v-bind:selected="selected"></slot>
				</template>

				<template v-slot:item.created_at="{ item }">{{ $formatTime(item.created_at) }}</template>
				<template v-slot:item.bean_type="{ item }">
					<v-chip
						size="small"
						label
						variant="tonal"
						:color="beanTypeColor(item.bean_type)"
						class="font-weight-medium"
					>
						{{ beanTypeLabel(item.bean_type) }}
					</v-chip>
				</template>
				<template v-slot:item.bean="{ item }">{{ item.bean?.name }}</template>
				<template v-slot:item.qty="{ item }">
					<div class="d-flex flex-column">
						<span class="font-weight-bold" :style="{ color: qtyColor(item.qty) }">
							{{ formatQty(item.qty) }}
							<span class="text-caption font-weight-regular ml-1">g</span>
						</span>
						<span class="text-caption text-medium-emphasis">
							{{ item.fromqty ?? 0 }} → {{ item.toqty ?? 0 }}
						</span>
					</div>
				</template>
				<template v-slot:item.ref_type="{ item }">{{ item.ref_type }}（{{ item.ref_id }}）</template>
				<template v-slot:item.action="{ item }">
					<slot name="actions" v-bind:item="item"></slot>
				</template>

				<template v-slot:footer.prepend>
					<slot name="batchActions" v-bind:selected="selected"></slot>
				</template>
			</v-data-table-server>
		</v-card-text>
	</div>
</template>

<script>
import { clone, valuesIn, toPairsIn, filter, intersection } from 'lodash-es'
import qs from 'qs'

export default {
	components: {},
	props: {
		beanId: { type: [Number, String], default: null },
		batchId: { type: [Number, String], default: null },
		type: { type: String, default: null },
		title: { type: String, default: null },
		showSelect: { type: Boolean, default: false },
		singleSelect: { type: Boolean, default: true },
		headers: {
			type: Array,
			default: () => [
				{ title: '#', value: 'id' },
				{ title: '日期', align: 'left', sortable: true, value: 'created_at' },
				{ title: '豆类型', sortable: true, value: 'bean_type' },
				{ title: '豆', sortable: true, value: 'bean' },
				{ title: '变动', sortable: true, value: 'qty' },
				{ title: '来源', sortable: true, value: 'ref_type' },
				{ title: '', align: 'left', sortable: false, value: 'action' }
			]
		}
	},
	data() {
		return {
			query: {},
			currentQuery: {}, //当前结果的查询条件
			objects: [],
			total: 0,
			loading: false,
			options: null,
			refs: {},
			selected: [],
			errors: {}
		}
	},
	mounted() {
		if (this.initQuery) {
			this.query = clone(this.initQuery)
		}
	},
	computed: {
		queryValues() {
			return filter(valuesIn(this.query), (e) => !!e)
		},
		currentQueryValues() {
			return filter(valuesIn(this.currentQuery), (e) => !!e)
		},
		queryPairs() {
			return filter(toPairsIn(this.query), (e) => !!e[1])
		}
	},
	watch: {},
	methods: {
		beanTypeLabel(type) {
			const map = { green: '生豆', roasted: '熟豆', blended: '拼配', ground: '粉', other: '其他' }
			return map[type] || type || '?'
		},
		beanTypeColor(type) {
			if (type === 'green') return 'success'
			if (type === 'roasted') return 'brown'
			return 'secondary'
		},
		formatQty(qty) {
			const n = Number(qty) || 0
			return n > 0 ? `+${n}` : `${n}`
		},
		qtyColor(qty) {
			const n = Number(qty) || 0
			if (n > 0) return '#2e7d32' // 增加
			if (n < 0) return '#c62828' // 减少
			return 'inherit'
		},
		search() {
			if (
				this.queryValues.length !== this.currentQueryValues.length ||
				intersection(this.queryValues, this.currentQueryValues).length !== this.queryValues.length
			) {
				//条件变化
				if (this.options.page === 1) {
					//当前如果是第一页，手动触发
					this.load()
				} else {
					this.options.page = 1 //当前不是第一页，修改后通过watcher触发
				}
			} else {
				//条件没变，忽略
			}
		},
		reset() {
			this.query = {}
		},
		load(options = null) {
			if (!this.options) this.options = {}
			if (options) {
				this.options = options
			}

			let { sortBy, page, itemsPerPage } = this.options
			this.loading = true
			let qwp = clone(this.query)
			qwp.pageno = page || 1
			qwp.pagesize = itemsPerPage || 10
			qwp.sortBy = 'id'
			qwp.sortDesc = 'desc'
			if (sortBy && sortBy.length > 0) {
				qwp.sort = sortBy.map((e) => `${e.key} ${e.order}`).join(',')
				qwp.sortBy = sortBy[0]['key']
				qwp.sortDesc = sortBy[0]['order']
			}

			this.currentQuery = clone(this.query)

			if (this.batchId) qwp['beanbatch_id'] = this.batchId
			if (this.beanId) qwp['bean_id'] = this.beanId
			this.$api.bean.searchBatchLog(
				qwp,
				(response) => {
					this.objects = response.objects
					this.total = response.total
					this.loading = false
				},
				(error) => {
					this.errors = error.message
					this.loading = false
				}
			)
		}
	}
}
</script>

<style scoped>
.silent td {
	color: rgba(3, 3, 3, 0.5) !important;
}
</style>
